var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"silver f6"},[_c('font-awesome-icon',{staticClass:"mr2",attrs:{"icon":['fa', 'user']}}),_vm._t("author")],2),_c('div',{staticClass:"lh-copy mv2 f6"},[_vm._t("comment")],2),_c('div',{staticClass:"silver f6"},[_vm._t("datetime")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }